<div class="sub-upgrade-card" [class.destructive]="isDestructive">
  <div class="sub-upgrade-close" (click)="dismiss()">
    <span class="material-icons">close</span>
  </div>
  <div class="sub-upgrade-icon">
    <span class="material-icons">{{ copy.icon }}</span>
  </div>
  <div class="sub-upgrade-title">
    <tidy-text [largeTitle]="copy.title" />
  </div>
  <div class="sub-upgrade-body">
    <tidy-text [body]="copy.body" />
  </div>

  <div class="sub-upgrade-summary">
    @for (item of lineItems; track item.title) {
      <div class="sub-upgrade-li">
        <div class="sub-upgrade-li-chip">
          <tidy-image [src]="item.icon" />
        </div>
        <div class="sub-upgrade-li-main">
          <div class="sub-upgrade-li-title">{{ item.title }}</div>
          @if (item.subtitle) {
            <div class="sub-upgrade-li-sub">{{ item.subtitle }}</div>
          }
        </div>
        <div class="sub-upgrade-li-amount" [class.struck]="item.struck">{{ item.amount }}</div>
      </div>
    }
    <div class="sub-upgrade-divider"></div>
    <div class="sub-upgrade-li">
      <div class="sub-upgrade-li-title">{{ copy.totalLabel }}</div>
      <div class="sub-upgrade-total">{{ total }}</div>
    </div>
  </div>

  <div class="sub-upgrade-actions">
    <tidy-button
      [text]="copy.confirmText"
      [action]="confirm"
      [disableLoadingStyle]="true"
      class="primary full-width" />
    @if (copy.dismissText) {
      <tidy-button
        [text]="copy.dismissText"
        [action]="dismiss"
        [disableLoadingStyle]="true"
        class="secondary full-width" />
    }
  </div>
</div>
